import { Modal } from '@tryhackme/thm-ui-components';
import { StyledInfoBoxes } from 'src/features/admin/tagging/tagging.styles';
export const TagCategoryHelpModal = ({
  open,
  onOpenChange
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => <Modal open={open} onOpenChange={onOpenChange} data-sentry-element="Modal" data-sentry-component="TagCategoryHelpModal" data-sentry-source-file="tag-category-help-modal.tsx">
    <StyledInfoBoxes data-testid="help-modal-contents" data-sentry-element="StyledInfoBoxes" data-sentry-source-file="tag-category-help-modal.tsx">
      <div>
        <h4>Tag Categories</h4>
        <p>
          A tag category acts as a way of grouping together tags. For instance, you may have tags representing operating
          systems which can be grouped into a &apos;Software&apos; category.
        </p>
      </div>
      <div>
        <h4>Subcategories</h4>
        <p>
          Sub categories act as a way of providing greater classification. Using the software example above, we could
          add a subcategory for &apos;Operating Systems&apos; to the Software category that houses the OS tags. We could
          then add other sub categories to Software like &apos;Mobile OS&apos; or &apos;Anti Virus&apos;.
        </p>
      </div>
      <div>
        <h4>Scopes</h4>
        <p>Scopes allow us to specify where in THM the particular category is relevant to</p>
      </div>
      <div>
        <h4>Restrict Tag Creation</h4>
        <p>
          Some categories have a predefined list of tags that shouldn&apos;t be modified outside of the admin page. This
          flag allows us to control at a category level where this is the case.
        </p>
      </div>
    </StyledInfoBoxes>
  </Modal>;